var _title, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgDataUpload = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "9px",
    viewBox: "0 0 17 9",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Available Filters - 01")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Demo",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5.-Settings---01",
    transform: "translate(-791.000000, -646.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-90",
    transform: "translate(773.000000, 622.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-57",
    transform: "translate(18.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outlined-/-Action-/-timeline",
    transform: "translate(0.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 17,
    height: 17
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2916667,5.66666667 C16.2916667,6.44583333 15.6541667,7.08333333 14.875,7.08333333 C14.7475,7.08333333 14.6270833,7.06916667 14.51375,7.03375 L11.9920833,9.54833333 C12.0275,9.66166667 12.0416667,9.78916667 12.0416667,9.91666667 C12.0416667,10.6958333 11.4041667,11.3333333 10.625,11.3333333 C9.84583333,11.3333333 9.20833333,10.6958333 9.20833333,9.91666667 C9.20833333,9.78916667 9.2225,9.66166667 9.25791667,9.54833333 L7.45166667,7.74208333 C7.33833333,7.7775 7.21083333,7.79166667 7.08333333,7.79166667 C6.95583333,7.79166667 6.82833333,7.7775 6.715,7.74208333 L3.49208333,10.9720833 C3.5275,11.0854167 3.54166667,11.2058333 3.54166667,11.3333333 C3.54166667,12.1125 2.90416667,12.75 2.125,12.75 C1.34583333,12.75 0.708333333,12.1125 0.708333333,11.3333333 C0.708333333,10.5541667 1.34583333,9.91666667 2.125,9.91666667 C2.2525,9.91666667 2.37291667,9.93083333 2.48625,9.96625 L5.71625,6.74333333 C5.68083333,6.63 5.66666667,6.5025 5.66666667,6.375 C5.66666667,5.59583333 6.30416667,4.95833333 7.08333333,4.95833333 C7.8625,4.95833333 8.5,5.59583333 8.5,6.375 C8.5,6.5025 8.48583333,6.63 8.45041667,6.74333333 L10.2566667,8.54958333 C10.37,8.51416667 10.4975,8.5 10.625,8.5 C10.7525,8.5 10.88,8.51416667 10.9933333,8.54958333 L13.5079167,6.02791667 C13.4725,5.91458333 13.4583333,5.79416667 13.4583333,5.66666667 C13.4583333,4.8875 14.0958333,4.25 14.875,4.25 C15.6541667,4.25 16.2916667,4.8875 16.2916667,5.66666667 Z",
    id: "\\uD83D\\uDD39-Icon-Color",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDataUpload, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/data_upload.d85325c6.svg";
export { ForwardRef as ReactComponent };